/**
 * Home: banner da categoria + carrossel de produtos.
 */
(function () {
  if (customElements.get('belabelly-cat-carousel')) return;

  class BelabellyCatCarousel extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this.scroller = this.querySelector('[data-belabelly-cat-scroller]');
      this.prevBtn = this.querySelector('[data-belabelly-cat-prev]');
      this.nextBtn = this.querySelector('[data-belabelly-cat-next]');
      if (!this.scroller) return;
      this._ready = true;

      this.prevBtn?.addEventListener('click', () => this.move(-1));
      this.nextBtn?.addEventListener('click', () => this.move(1));
      this.scroller.addEventListener('scroll', () => this.sync(), { passive: true });
      this._ro = new ResizeObserver(() => this.sync());
      this._ro.observe(this.scroller);
      this.sync();
    }

    disconnectedCallback() {
      this._ro?.disconnect();
    }

    slideSize() {
      const slide = this.scroller.querySelector('.belabelly-cat-carousel__slide');
      if (!slide) return this.scroller.clientWidth * 0.8;
      const styles = getComputedStyle(this.scroller);
      const gap = parseFloat(styles.columnGap || styles.gap) || 16;
      return slide.getBoundingClientRect().width + gap;
    }

    move(dir) {
      this.scroller.scrollBy({ left: dir * this.slideSize(), behavior: 'smooth' });
    }

    sync() {
      const el = this.scroller;
      const max = el.scrollWidth - el.clientWidth - 2;
      const canScroll = max > 2;
      this.classList.toggle('is-scrollable', canScroll);
      const atStart = el.scrollLeft <= 2;
      const atEnd = el.scrollLeft >= max;
      if (this.prevBtn) this.prevBtn.disabled = !canScroll || atStart;
      if (this.nextBtn) this.nextBtn.disabled = !canScroll || atEnd;
    }
  }

  customElements.define('belabelly-cat-carousel', BelabellyCatCarousel);
})();
